import React from 'react';
import logo from '../assests/img/logo2.png';
import mobilelogo from '../assests/img/logo-mobile.jpg';
import shortlogo from '../assests/img/ad-circle.png';
import Topmenuleft from './Topmenuleft';
import Topmenuright from './Topmenuright';
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { useState, useEffect } from "react";
import Mobilemenu from './Mobilemenu';
import { CiMenuFries } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";


function Header() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isDarkMode]);


  return (
    <>
      <header>
      <div className='container'>
        <div className='row'>
          <div className='col-md-5 upcoming-event-box'>
            <div className='top-social'>

                <ul className='flex'>
                  <li> <a href="https://www.facebook.com/AadikaashInternational/"><FaFacebook /></a></li>
                               <li>  <a href="https://www.youtube.com/@aadikaashinternational4730"><FaYoutube /></a></li>
                               <li>  <a href="https://www.instagram.com/aadikaashofficial/"><FaInstagram /></a></li>
                </ul>

            </div>
               {/* <h2><Link to='/isjs2025' className=''>Silver Show in Jaipur | 2025</Link></h2> 
               <h3>8-9-10 November 2025, JECC, Sitapura, Jaipur</h3>     */}
              <ul className='login'>    

                       {/* <li> <Link to='/' className='order-history-link'>Jaipur - ISJS 2026 Exhibitor Form</Link></li>          */}
              {/* <li><Link to='/login' className='order-history-link'><span class="blink-live upcoming">upcoming</span>Visitor Registration</Link> </li> */}
              </ul> 
              <Topmenuleft/>          
          </div>
          <div className='col-md-2 main-logo-box'>
          <Link to='/' className='logo-img-box'>
            <img className='main-logo' src={logo}/>
            <img className='c-logo' src={shortlogo}/>
            </Link>

            <Link to='/' className='logo-img-box-mobile'>
            <img className='main-logo-mobile' src={mobilelogo}/>
            </Link>

           <button className='menu-toggle-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
           {/* <CiMenuFries />  */}<span class="menu-title">Menu</span>
           </button>

          </div>
          <div className='col-md-5 upcoming-event-box'>
          <div className='top-contact'>
          <ul className='flex'>                  
                   <li> <a href="https://www.facebook.com/taleofjewel?mibextid=wwXIfr&rdid=F0b4nMmN6mmU0K1H&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1EGuGyQwnY%2F%3Fmibextid%3DwwXIfr#" target="_blank">Media</a></li>
                   <li> <a href="/contact">Contact Us</a></li>
                </ul>

          </div>
          {/* <h2><Link to='/asjs2025' className=''>Silver Show in Agra | 2025</Link></h2> */}
          {/* <h3>7-8-9 September 2025, Agra, Utter Pradesh</h3>     */}
          <ul className='login'>             
                 {/* <li> <Link to='/' className='order-history-link'>Jaipur - ISJS 2026 Exhibitor Form</Link></li> */}
          </ul>
          <Topmenuright/>
          </div>
        </div>
      </div>

      <div className='mobile-menu'>
      <button className='menu-close-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
      <IoMdClose />
          </button>
        <Mobilemenu/>
      </div>
    
      </header>
     
      </>
  )

}

export default Header;
